import { ZoomInOutlined, ZoomOutOutlined } from '@ant-design/icons'
import { Button, Flex, theme } from 'antd'
import { useContext } from 'react'
import { CustomizeDiagramViewPortContext, DiagramViewPortContext } from '../DiagramViewPortContext.tsx'

const { useToken } = theme

export const DiagramToolbar = () => {
    const { token } = useToken()
    const { zoomMode } = useContext(DiagramViewPortContext)
    const {
        resetViewPort,
        resetZoomOnClick,
        setZoomOutOnClick,
        setZoomInOnClick
    } = useContext(CustomizeDiagramViewPortContext)

    return (<Flex
        style={{ margin: token.marginXS, position: 'absolute', right: 0, zIndex: 1 }}
        gap={6}
        justify='center'
        align='center'
    >
        <Button
            size='small'
            onClick={resetViewPort}
        >Reset</Button>
        <Button
            size='small'
            type={zoomMode === 'in' ? 'link' : 'default'}
            onClick={zoomMode !== 'in' ? setZoomInOnClick : resetZoomOnClick}
            icon={<ZoomInOutlined />}
        ></Button>
        <Button
            size='small'
            type={zoomMode === 'out' ? 'link' : 'default'}
            onClick={zoomMode !== 'out' ? setZoomOutOnClick : resetZoomOnClick}
            icon={<ZoomOutOutlined />}
        ></Button>
    </Flex>)
}
